import React from 'react';
import styles from './PageWrapper.module.scss';
import Header from '../Header';
import Footer from '../Footer';
import { Toast } from '../../ui';
import ConfirmationModal from '../../ConfirmationModal';

interface PageWrapperProps {
  children: React.ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  showHeader = true,
  showFooter = true,
}) => {
  return (
    <div className={styles.pageWrapper}>
      {showHeader && <Header />}
      <main className={styles.main}>{children}</main>
      {showFooter && <Footer />}
      <Toast />
      <ConfirmationModal />
    </div>
  );
};

export default PageWrapper;
